import LinkButton, { LinkButtonKind, LinkButtonSize } from '@/components/UI/Buttons/LinkButton/LinkButton'
import styles from './DiscoverBanner.module.css'
import Icon_SoraStream from '@/assets/img/Icon_Favicon.svg'
import { useTranslations } from 'next-intl'
import Image_Background from '@/assets/img/Image_DiscoverBannerBackground.png'
import Image_GamesBackground from '@/assets/img/Image_DiscoverGamesBackground.png'
import Image from 'next/image'

export default function DiscoverBanner() {
    const t = useTranslations('FrontPage.DiscoverBanner')
    return (
        <div className={styles.main}>
            <Image src={Image_GamesBackground} alt={'Side Image'} className={styles.games} priority />
            <div className={styles.wrapper}>
                <Image src={Image_Background} alt='background' className={styles.image} />
                <Icon_SoraStream />
                <div className={styles.info}>
                    <h3 className='title3'>{t('title')}</h3>
                    <p className='bodyTextMedium'>{t('description')}</p>
                </div>
                <LinkButton size={LinkButtonSize.MEDIUM} kind={LinkButtonKind.SUGGESTED} href={'/#plans'}>{t('seePlans')}</LinkButton>
            </div>
        </div>
    )
}